import { observer } from "mobx-react-lite";
import React, { useContext, useEffect, useState } from "react";
import { RootStoreContext } from "../../app/stores/rootStore";

// reactstrap components
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import classnames from "classnames";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { translationHookOptions } from "../../app/localization/localization";

interface IProps {
  title: string;
  isOpen: boolean;
  size?: string;
  toggle: () => void;
  action: () => void;
  showCancelButton?: boolean;
  messages?: string | string[];
  jsxMessage?: JSX.Element;
  classNamesObj? : IClassNames;
}
interface IClassNames {
  modalClassname?: string;
  headerClassname?: string;
  bodyClassname?: string;
  footerClassname?: string;
  confirmButtonClassname?: string;
}

const GenericConfirmModal: React.FC<IProps> = ({
  isOpen,
  toggle,
  action,
  title,
  size,
  messages,
  jsxMessage,
  classNamesObj,
  showCancelButton,
}) => {
  const rootStore = useContext(RootStoreContext);
  const { theme } = rootStore.commonStore;
  const [t] = useTranslation(["translation"], translationHookOptions);
  const [classNamesToAssign, setClassNamesToAssign] = useState<IClassNames>({modalClassname: "",headerClassname: "",bodyClassname: "",footerClassname : "",confirmButtonClassname: ""})

  useEffect(()=> {
    if(classNamesObj)
    setClassNamesToAssign((prev) => {
    return{
      modalClassname : classNamesObj.modalClassname ?? "",
      headerClassname : classNamesObj.headerClassname ?? "",
      bodyClassname : classNamesObj.bodyClassname ?? "",
      footerClassname : classNamesObj.footerClassname ?? "",
      confirmButtonClassname : classNamesObj.confirmButtonClassname ?? ""
    }});
  },[classNamesObj])

  const handleConfirm = () => {
    action();
    toggle();
  };

  const handleCancel = () => {
    toggle();
  };

  return (
    <Modal
      className={classNamesToAssign.modalClassname}
      isOpen={isOpen}
      toggle={toggle}
      size={size ? size : "lg"}
    >
      {title && (
        <ModalHeader
          style={{ height: "10px" }}
          className={classnames(
            `${theme!.headerModal} ${theme!.headerTextColor} ${classNamesToAssign.headerClassname}`
          )}
          close={
            <button
              className="closeModalIcon"
              onClick={() => {
                toggle();
              }}
            >
              <i className="far fa-times-circle fa-lg"></i>
            </button>
          }
          toggle={toggle}
        >
          {title}
        </ModalHeader>
      )}
      <ModalBody className={classNamesToAssign.bodyClassname}>{
      jsxMessage ? jsxMessage :
      (
      typeof(messages) ==="string" ? messages 
      :
      <div style={{display: "flex",flexDirection: "column"}}>
        {messages && messages.map((message, index) =>
        <p key={"confirmModalMessage_" + index}>{message}</p> )}
      </div>
      )
      }</ModalBody>
      <ModalFooter className={classNamesToAssign.footerClassname} style={{display: showCancelButton === false ? "flex": "", justifyContent: showCancelButton === false ? "center" : ""}}>
        {showCancelButton && showCancelButton === true && (
          <Button
          className={classNames(
            "genericButton",
            `${theme!.buttonSecondaryColor} ${
              theme!.buttonSecondaryBorderColor
            } ${theme!.buttonSecondaryTextColor}`
          )}
          onClick={handleCancel}
          >
          {t("cancel")}
          </Button>
        )}
        <Button
          className={classNames(
            "genericButton",
            `${theme!.buttonColor} ${theme!.buttonBorderColor} 
            ${theme!.buttonTextColor} ${classNamesToAssign.confirmButtonClassname}`
          )}
          onClick={handleConfirm}
        >
          {t("confirm")}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default observer(GenericConfirmModal);
